import {Route, Navigate} from 'react-router-dom';

export const createProtectedRoute = (path, component, authorizationCheck) => {
    return (
        <Route
            path={path}
            element={
                authorizationCheck() ? component : <Navigate to="/accedi" replace/>
            }
        />
    );
};